import {IEntity} from "../../../typescript-plugin/entities/IEntity";
import {Key} from "../../../typescript-plugin/entities/Key";
import {IdKey} from "../../../typescript-plugin/entities/IdKey";

export class Employee implements IEntity{

    id:string;
    name:string;
    job:string;
    picture:string;

    Key(): Key {
        return new IdKey(this.id);
    }

    Serialize(): {} {
        return {
            name: this.name,
            job: this.job,
            picture: this.picture,
            id: this.id
        };
    }

    Deserialize(data: {}): void {
        this.name = data['name'];
        this.job = data['job'];
        this.picture = data['picture'];
        this.id = data['id'];
    }

    ToEntity(data: {}): void {
        return this.Deserialize(data);
    }

    ToPersistable(): {} {
        return this.Serialize();
    }

    IsValid():boolean{
        return this.name != null && this.name != '' &&
               this.job != null && this.job != '' &&
               this.picture != null && this.picture != '';
    }

    AsFake():Employee{
        this.id = "Id";
        this.name = "John Smith";
        this.job = "Computer scientist";
        this.picture = "http://localhost:4200/assets/img/car-sample.jpg";
        return this;
    }

}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/server/src/base/entities/employee/Employee.ts